module.exports = __webpack_public_path__ + "assets/img/g_medium.116983e9.png";